import { useInfiniteQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { RewardRepositoryImpl } from "../../data/repository/reward_repository_impl";
import { RewardInterface } from "../../../home/domain/interface/reward_interface";
import { useMemo } from "react";
import { useOutletContext } from "react-router-dom";
import { UserInterface } from "../../../../core/components/user/domain/interfaces/user_interface";

interface PaginatedExceptionalRewardsResponse {
    rewards: RewardInterface[];
    fetchedAll: boolean;
}

export const useGetExceptionalRewards = (limit: number = 10, filters: string[]) => {
    const repository = new RewardRepositoryImpl();
    const { company } = useOutletContext<UserInterface>();

    const query = useInfiniteQuery<PaginatedExceptionalRewardsResponse, AxiosError>({
        queryKey: ['exceptionalRewards', limit, company?.id, filters],
        queryFn: async ({ pageParam = 0, }) => {
            const result = await repository.getExceptionalRewards(pageParam as number, limit, filters);

            return {
                rewards: result.rewards,
                fetchedAll: result.fetchedAll
            };
        },
        retry: 4,
        staleTime: 5 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
        getNextPageParam: (lastPage, allPages) => {
            const currentPageNumber = allPages.length;

            if (!lastPage.fetchedAll) {
                return currentPageNumber * limit;
            }
            return undefined;
        },
        initialPageParam: 0,
    });

    const allExceptionalRewards = useMemo(() => {
        const rewards = query.data?.pages.flatMap(page => page.rewards) || [];
        return rewards;
    }, [query.data]);

    
    return {
        ...query,
        allExceptionalRewards
    }
};